import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ClientTable from './Table';
import { useTypedSelector } from 'src/hooks/useTypeSelector';

const ClientPage: FC = () => {
  const navigate = useNavigate();
  const { role } = useTypedSelector(state => state.auth);

  useEffect(() => {
    if (role !== 'admin') navigate('/');
  }, [role]);

  return <ClientTable />;
};

export default ClientPage;
